import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { CustomerDetails } from 'src/app/models/basket';
import { ContentService } from 'src/app/services/content/content.service';
import { TextInputComponent } from 'src/app/shared/components';
import { TypedFormGroup } from 'src/app/shared/forms';
import { ContentSection } from 'src/app/shared/layout/content-section';

@Component({
  selector: 'app-gift-card-delivery',
  templateUrl: './gift-card-delivery.component.html',
  styleUrls: ['./gift-card-delivery.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReactiveFormsModule, MatRadioModule, TextInputComponent],
})
export class GiftCardDeliveryComponent extends ContentSection implements OnInit {
  @Input() form!: TypedFormGroup<CustomerDetails>;
  @Input() title: string;

  enableEAN: boolean;
  billingAddressContent: {
    firstNameLabel: string;
    firstNamePlaceholder: string;
    lastNameLabel: string;
    lastNamePlaceholder: string;
    emailLabel: string;
    emailPlaceholder: string;
    phoneLabel: string;
    phonePlaceholder: string;
    companyLabel: string;
    companyPlaceholder: string;
    CVRLabel: string;
    CVRPlaceholder: string;
    eanLabel: string;
    eanPlaceholder: string;
    requisitionLabel: string;
    requisitionPlaceholder: string;
    invoiceRecipientNameLabel: string;
    invoiceRecipientNamePlaceholder: string;
    invoiceRecipientEmailLabel: string;
    invoiceRecipientEmailPlaceholder: string;
    addressLabel: string;
    addressPlaceholder: string;
    zipCodeLabel: string;
    zipCodePlaceholder: string;
    cityLabel: string;
    cityPlaceholder: string;
  };

  constructor() {
    const contentService = inject(ContentService);
    super(contentService, 'basketShipping', { meta: true });

    // Delivery content
    this.billingAddressContent = {
      firstNameLabel: this.content.get('billingFirstNameLabelText'),
      firstNamePlaceholder: this.content.get('billingFirstNamePlacerholderText'),
      lastNameLabel: this.content.get('billingLastNameLabelText'),
      lastNamePlaceholder: this.content.get('billingLastNamePlaceholderText'),
      emailLabel: this.content.get('billingEmailLabelText'),
      emailPlaceholder: this.content.get('billingEmailPlaceholderText'),
      phoneLabel: this.content.get('billingPhoneLabelText'),
      phonePlaceholder: this.content.get('billingPhonePlaceholderText'),
      companyLabel: this.content.get('billingCompanyNameLabelText'),
      companyPlaceholder: this.content.get('billingCompanyNamePlaceholderText'),
      CVRLabel: this.content.get('billingCVRLabelText') || 'CVR',
      CVRPlaceholder: this.content.get('billingCVRPlaceholderText') || 'Indtast CVR nummer',
      eanLabel: this.content.get('billingEanLabelText') || 'EAN',
      eanPlaceholder: this.content.get('billingEanPlaceholderText') || 'Indtast EAN (13 tegn)',
      requisitionLabel: this.content.get('billingRequisitionLabelText') || 'Rekvisitionsnummer',
      requisitionPlaceholder: this.content.get('billingRequisitionPlaceholderText') || 'Indtast rekvisitionsnummer',
      invoiceRecipientNameLabel: this.content.get('billingInvoiceRecipientNameLabel') || 'Navn på modtager af faktura',
      invoiceRecipientNamePlaceholder: this.content.get('billingInvoiceRecipientNamePlaceholder') || 'Indtast navn på modtager af faktura',
      invoiceRecipientEmailLabel: this.content.get('billingInvoiceRecipientEmailLabel') || 'E-mail på modtager af faktura',
      invoiceRecipientEmailPlaceholder:
        this.content.get('billingInvoiceRecipientEmailPlaceholder') || 'Indtast e-mail på modtager af faktura',
      addressLabel: this.content.get('billingAddressLabelText'),
      addressPlaceholder: this.content.get('billingAddressPlaceholderText'),
      zipCodeLabel: this.content.get('billingZipCodeLabelText'),
      zipCodePlaceholder: this.content.get('billingZipCodePlaceholderText'),
      cityLabel: this.content.get('billingCityLabelText'),
      cityPlaceholder: this.content.get('billingCityPlaceholderText'),
    };
  }

  ngOnInit() {
    const merchant = this.contentService.getMerchant();
    this.enableEAN = merchant.enableEAN;
  }

  toggleBusiness() {
    this.form.controls.isBusiness.value = !this.form.controls.isBusiness.value;
    this.form.controls.isBusiness.updateValueAndValidity();
    this.form.controls.payment.controls.CVR.updateValueAndValidity();
  }
}
